module.exports = __webpack_public_path__ + "img/cb-fullscreen.514d2942.svg";